import React, { useContext } from 'react'
import 'stylesheets/TimerAppStyles/TodoItem.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { AppContext } from 'contexts/TimerAppContexts/AppContext'


const TodoItem = ({ id, text, completed, category, intensity, onComplete, onDelete, totalPomodoros, completedPomodoros }) => {
    const {setOpenTimerModal, setTotalPomodoros, setTimerName, setTimerKey} = useContext(AppContext)
    const handlePomoUI = (text)=>{
        setOpenTimerModal(true)
        setTimerName(text)
        setTotalPomodoros(totalPomodoros)
        setTimerKey(id)
    }
    return (
        <li className={`todo-item ${completed ? 'completed' : 'uncompleted'}`}>
            <FontAwesomeIcon icon={faCircleXmark} className='todo-close-icon' onClick={onDelete} />
            <div className='todo-info'>
                <p className='todo-text'>{text}</p>
                <p className='todo-category'>{category}</p>
                <p className={`todo-intensity ${intensity}`}>{intensity.charAt(0).toUpperCase() + intensity.slice(1)}</p>
            </div>
            <div className='todo-info-right'>
                <button disabled={(completedPomodoros === totalPomodoros ? true : false)} className='btn-start' type='button' onClick={()=>{handlePomoUI(text)}}><FontAwesomeIcon icon={faPlay}/></button>
                <p className='todo-count-info'><span>{completedPomodoros}</span>/{totalPomodoros}</p>
            </div>
        </li>
    )
}

export { TodoItem }